export var removeEmptyObjects = function (obj) {
    if (Array.isArray(obj)) {
        return obj.length === 0
            ? undefined
            : obj
                .map(removeEmptyObjects)
                .filter(function (item) { return item !== undefined && item !== null; });
    }
    if (obj && typeof obj === "object") {
        var cleanedObj = {};
        for (var key in obj) {
            var cleanedValue = removeEmptyObjects(obj[key]);
            if (cleanedValue !== undefined &&
                cleanedValue !== null &&
                cleanedValue !== "") {
                cleanedObj[key] = cleanedValue;
            }
        }
        return Object.keys(cleanedObj).length === 0 ? undefined : cleanedObj;
    }
    return obj;
};
